<h2 class="wizard_step-title text--title-bold">{{ 'deviceAssignment' | translate | titlecase }}</h2>

<div class="device-mode-cards">
  <div
    class="device-mode-card"
    [ngClass]="{ 'device-mode-card--active': mode === 'existing' }"
    (click)="setMode('existing')">
    <i class="fas fa-link device-mode-card_icon"></i>
    <span class="device-mode-card_label">{{ 'assignExistingDevice' | translate }}</span>
  </div>
  <div
    class="device-mode-card"
    [ngClass]="{ 'device-mode-card--active': mode === 'new' }"
    (click)="setMode('new')">
    <i class="fas fa-plus device-mode-card_icon"></i>
    <span class="device-mode-card_label">{{ 'createNewDevice' | translate }}</span>
  </div>
</div>

<!-- Assign existing device -->
<ng-container *ngIf="mode === 'existing'">
  <app-input-wrapper [control]="deviceControl" label="{{ 'device' | translate }}">
    <mat-select
      class="form_control"
      [formControl]="deviceControl"
      [compareWith]="compareDevices"
      (selectionChange)="onExistingSelect($event.value)"
      disableOptionCentering
      panelClass="dropdown"
      aria-label="{{ 'device' | translate }}">
      <mat-optgroup [label]="'devicesNoScheduledTests' | translate">
        <mat-option *ngFor="let device of availableDevices" [value]="device">
          {{ device.name }}: {{ device.code }}
        </mat-option>
      </mat-optgroup>
      <mat-optgroup [label]="'devicesInUse' | translate">
        <mat-option *ngFor="let device of occupiedDevices" [value]="device">
          {{ device.name }}: {{ device.code }}
          <ng-container *ngIf="device.has_running_test"> &mdash; {{ 'deviceTestInProgress' | translate }}</ng-container>
          <ng-container *ngIf="!device.has_running_test && device.pending_scheduled_test_count"> ({{ device.pending_scheduled_test_count }})</ng-container>
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </app-input-wrapper>

  <div *ngIf="selectedDevice && reallocate" class="reallocate-notice">
    <i class="fas fa-exclamation-triangle"></i>
    <span>{{ 'reallocateDeviceNotice' | translate }}</span>
  </div>
</ng-container>

<!-- Create new device: reuses the standard device form, with the device type
     hidden and locked to "Home Device (H)". The device is not created here -
     the captured values are created when the wizard is finished. -->
<ng-container *ngIf="mode === 'new'">
  <app-device-form
    [device]="null"
    [initialValue]="initialNewDevice"
    [embedded]="true"
    [lockedDeviceType]="homeDeviceType"
    action="{{ 'new' | translate }}"
    (validChange)="createFormValid = $event">
  </app-device-form>
</ng-container>

<div class="wizard_footer">
  <button class="button button--secondary" type="button" (click)="back.emit()">
    <span class="regular">{{ 'back' | translate }}</span>
  </button>
  <button class="button button--primary" type="button" [disabled]="!canProceed" (click)="onNext()">
    <span class="regular">{{ 'next' | translate }}</span>
  </button>
</div>

<app-loader *ngIf="isLoading"></app-loader>
